var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstallLine = function SvgInstallLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.3 3v1.8H5.7v9h12.6v-9h-3.6V3h4.5a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9zm9 12.6H5.7v3.6h12.6zm-1.8.9v1.8h-1.8v-1.8zM12.9 3v4.5h2.7L12 11.1 8.4 7.5h2.7V3z"
  })));
};
export default SvgInstallLine;